module.exports = __webpack_public_path__ + "img/exit.d3e77cf0.svg";